<template>
  <SmallSquare content='优惠券：是商城的一款促销工具，该券不能设置满减，用户付款时可直接减免券中对应金额。
  现金券可与代金券/折扣券叠加使用' ></SmallSquare>
  <a-card :bordered="false">
    <div class="m-b-20 s_flex_bian_c">
        <a-button type="primary" v-has:couponCardCreate="()=>{showAdd = true}">
          <PlusOutlined />
          新增优惠券
        </a-button>
    </div>
    <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
      :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="关键词" name='keyword'>
        <a-input v-model:value="search.keyword" style="width:270px" placeholder="请输入卡券名称进行搜索" />
      </a-form-item>
      <a-form-item label="券状态" name='status'>
        <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">正常</a-select-option>
          <a-select-option :value="0">失效</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="券类型" name='coupon_type'>
        <a-select v-model:value="search.coupon_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部类型</a-select-option>
          <a-select-option :value="2">现金券</a-select-option>
          <a-select-option :value="3">代金券</a-select-option>
          <a-select-option :value="1">折扣券</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
      <!-- <a-form-item>
        <a-button type="primary" ghost>导出</a-button>
      </a-form-item> -->
    </a-form>
    <a-table :pagination='false' :loading='listLoading' class='tableFixBox' bordered rowKey='id' :columns='columns' :data-source='data' :scroll="{ x: 'max-content'}">
      <template v-slot:amount_text="{ record }">
        <p>{{record.amount_text}}</p>
        <p>{{record.use_condition}}</p>
      </template>
      <template v-slot:action="{ record }">

        <a-button v-has:couponRelation='()=>{showRelation = true;itemId=record.id}' class="m-r-10">查看关联活动</a-button>
          <a-button  v-has:couponCardEdit="()=> {$router.push('/assets/coupons/couponCard/edit?type=edit&id='+record.id)}"  class="m-r-10" type="primary">编辑</a-button>
          <a-button  v-has:couponStatus='()=>invalid(record)' class="m-r-10" danger v-if='record.status == 0 || record.status == 1'>{{record.status == 0 ? '使生效':'使失效'}}</a-button>
        <a-button  v-has:couponDel='()=>del(record)' class="m-r-10" danger  v-if='!record.status'>删除</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"  @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal  :keyboard="false" title="选择优惠券类型" centered v-model:visible="showAdd" destroyOnClose :footer="null">
    <div class="s_flex_bian_c">
      <div class="text-ac width33" @click="()=> {$router.push('/assets/coupons/couponCard/add?type=add&card=2')}">
        <RedEnvelopeFilled class="fz-50 s_c376" />
        <p class="fz-18 s_font_b m-t-10">现金券</p>
        <p class="s_c999 m-t-5">无门槛减免券</p>
      </div>
      <div class="text-ac width33" @click="()=> {$router.push('/assets/coupons/couponCard/add?type=add&card=3')}">
        <MoneyCollectFilled class="fz-50 s_c376" />
        <p class="fz-18 s_font_b m-t-10">代金券</p>
        <p class="s_c999 m-t-5">订单满减券</p>
      </div>
      <div class="text-ac width33" @click="()=> {$router.push('/assets/coupons/couponCard/add?type=add&card=1')}">
        <TagFilled class="fz-50 s_c376" />
        <p class="fz-18 s_font_b m-t-10">折扣券</p>
        <p class="s_c999 m-t-5">订单折扣券</p>
      </div>
    </div>
  </a-modal>
  <a-modal  :keyboard="false" title="关联活动" :width='1300' centered v-model:visible="showRelation" destroyOnClose :footer='null'>
    <relationList :id='itemId'></relationList>
  </a-modal>
</template>
<script>
  import { DownOutlined, PlusOutlined, ExclamationCircleOutlined,RedEnvelopeFilled,MoneyCollectFilled,TagFilled } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs ,createVNode,h} from "vue";
  import { message } from "ant-design-vue";
  import { getNewCouponList, newCouponState, newCouponDel } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import relationList from './components/relationList.vue' 
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    type:'all',
    keyword: "",
    status: '',
    coupon_type: '',
    start_time:'',
    end_time:''
  };
  export default {
    components: {  PlusOutlined,RedEnvelopeFilled,MoneyCollectFilled,TagFilled ,relationList},
    setup() {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        showAdd: false,
        listLoading: false,
        time: [],
        total: 1,
        showRelation:false,
        itemId:''
      });
      let columns = [
        {
          title: "卡券ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "优惠",
          key: "amount_text",
          dataIndex:"amount_text",
          align:"center",
          slots: { customRender: "amount_text" },
        },
        {
          title: "券类型",
          dataIndex: "coupon_type_text",
          key: "coupon_type_text",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
        },
        {
          title: "适用商品",
          dataIndex: "product_type",
          key: "product_type",
        },
        {
          title: "有效期",
          key: "valid_period_time",
          dataIndex:'valid_period_time'
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: ({ record }) => {
            return record.remark ? record.remark : '-'
          }
        },
        {
          title: "操作",
          key: "action",
           fixed: 'right',
          slots: { customRender: "action" },
        },
      ];
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      const invalid = async(e) => {
        $Modal.confirm({
          centered: true,
          width: 500,
          title: '确定要使优惠券'+(e.status ? '失效':'重新生效')+'吗？',
          icon: createVNode(ExclamationCircleOutlined),
          content: h('div', {}, [
            h('p', { className: 'm-b-15' },
            e.status ? '1、失效后，买家无法再领取该优惠券':'如若重新生效前，此组优惠券已过有效期，则该券会变成过期券。如若未过期，该券继续有效。'),
            h('p', e.status ? '2、买家之前已领取到的优惠券，在有效期内还能继续使用。':''),
          ]),
          onOk:async()=> { 
            let res = await newCouponState({id:e.id}).then(res => res.data);
            if (iscode(res,true)) {
              setTimeout(()=>{
                initData(search.value);
              },1000)
            }
          }
        });
      }
      const del = (e) =>{
        $Modal.confirm({
          centered: true,
          width: 500,
          title: '温馨提示',
          icon: createVNode(ExclamationCircleOutlined),
          content: h('div', {}, [
            h('p', '删除后该卡券将无法恢复，您确定要删除该卡券吗？')
          ]),
          onOk:async()=> { 
            let res = await newCouponDel({id:e.id}).then(res => res.data);
            if (iscode(res,true)) {
              setTimeout(()=>{
                initData(search.value);
              },1000)
            }
          }
        });
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getNewCouponList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        invalid,
        onChange,
        del
      };
    },
  };
</script>